import { render, staticRenderFns } from "./AddCategoryDialog.vue?vue&type=template&id=a52bffbe"
import script from "./AddCategoryDialog.vue?vue&type=script&lang=js"
export * from "./AddCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCategoryDialog.vue?vue&type=style&index=0&id=a52bffbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports